import {Sync} from '../../../client/sync'
import {Task} from '../../../extensions/task'
import {TaskData} from 'yougile-model'
import {taskDataFromHub} from '../../../extensions/task-data-extractor'
import {DepartmentsClient} from '../../../client/departments-client'

export const getAllCards = (start: number, stop: number): TaskData[] => {
  const box = Sync.getCurrentSandbox()
  const res: TaskData[] = []
  const hierarchy = DepartmentsClient.getHierarchy(box)
  Task.forEachTask(box, hierarchy, task => {
    if (
      (!start || task.timestamp >= start) &&
      (!stop || task.timestamp < stop) &&
      !Task.isArchived(task)
    ) {
      const data = taskDataFromHub(box, task)
      if (data && !task.data.private) {
        res.push(data)
      }
    }
  })
  return res
}
